<div class="modal-body">
	<div class="row">
		<div class="col-12 d-flex justify-content-between align-items-center">
			<p class="header-text poppins">ASSIGN SCORER</p>
			<img src="assets/img/shared/close-icon.svg" class="close-icon pointer" alt="" (click)="close()">
		</div>
		<div class="col-12">
			<p class="sub-text poppins">Please check all the information before submitting.</p>
		</div>
	</div>
	<div class="row">
		<form [formGroup]="form">
			<div class="col-12">
				<mat-form-field appearance="outline" class="w-100">
					<mat-label>Scorers</mat-label>
					<mat-select formControlName="scorerId">
						<mat-option value="{{item?.scorerId}}" *ngFor="let item of scorers">{{ item?.scorerName }}</mat-option>
					</mat-select>
				</mat-form-field>      
			</div>
		</form>
	</div>
	<div class="row">
		<div class="col-12 d-flex justify-content-center">
			<button class="btn submit poppins" type="button" (click)="confirm()">ASSIGN</button>  
		</div>
	</div>
</div>